<p *cdxEmbedded="'hide'">
	<ng-container *ngIf="totalRecipes">{{ totalRecipes | number }}</ng-container>
	{{
		totalRecipes
			| i18nPlural
				: {
						'=0': searchMode ? 'No Results' : 'No Recipes',
						'=1': searchMode ? ' search result' : ' Recipe',
						other: searchMode ? ' search results' : ' Recipes'
				  }
	}}
</p>
<ng-container *ngIf="totalRecipes > 0; else noResults">
	<div class="headingSection" *ngIf="!searchMode && !isEmbeddedInApp; else searchQuery">
		<h1 tabindex="-1" [cdxFocusOnChange]="title">{{ title }}</h1>
		<p *ngIf="description">{{ description }}</p>
	</div>
	<div
		#subCatsArea
		*ngIf="subCategories?.length"
		[ngClass]="{ subCategories: true, 'subCategories--expanded': showMore }"
	>
		<ul>
			<li *ngFor="let category of subCategories; trackBy: trackByFn">
				<a cdxButton fillStyle="secondaryOutline" [inline]="true" [chip]="true" [routerLink]="getSubCategoryPath(category.id, category.description)" (click)="handleCategoryClick(category)">
					{{ category.description }}
				</a>
			</li>
		</ul>
	</div>
	<div class="showMore" *ngIf="displayShowMoreToggle">
		<hr />
		<div [ngClass]="{ 'showMore-text': true, 'showMore-text--expanded': showMore }" (click)="showMore = !showMore">
			{{ showMore ? 'Fewer Categories' : 'More Categories' }}
			<cdx-svg-icon name="chevron-bottom" size="extra-small" fill="dark"></cdx-svg-icon>
		</div>
		<hr />
	</div>
</ng-container>
<ng-template #noResults>
	<p>We couldn't find anything for ...</p>
	<ng-container *ngTemplateOutlet="searchQuery"></ng-container>
	<p>but we have some other recipes you might like</p>
</ng-template>

<ng-template #searchQuery>
	<h1 *ngIf="isSearchQueryVisible" tabindex="-1" [cdxFocusOnChange]="title">&lsquo;{{ title }}&rsquo;</h1>
</ng-template>
